export default "__VITE_ASSET__79ZpTP43__"